export type OpenSysDlgSelectPathRequest = {
  filename: string;
  intention?: UnifyWebviewPathIntention;
};

export type OpenSysDlgSelectPathResponse = {
  pathId: string;
};

export type OpenSysDlgSelectDirectoryRequest = {
  intention?: UnifyWebviewPathIntention;
};

export type OpenSysDlgSelectDirectoryResponse = OpenSysDlgSelectPathResponse;

export type SaveAsFileRequest = {
  fileStream: string | ArrayBufferLike;
  pathId?: string;
};

export type SaveAsFileResponse = {
  returnCode: number; // 0-success
  errorMsg?: string;
};

export type FilePickerRequest = {
  multiSelect: boolean;
  maxSelectFileCount: number;
  fileType: UnifyWebViewFileType;
};

export type FileInfo = {
  pathId: string;
  fileSize: number;
  fileName: string;
  contentType: string;
};

export type FileAbility = {
  supportBinary: boolean;
  supportHttpFetchInterrupt: boolean;
  httpFetchInterruptPath: string;
  maxRangeSize: number;
};

export type FileRangeInfo = {
  rangeStart?: number;
  rangeEnd?: number;
  pathId: string;
};

export type FileRangeResponse = {
  fileData: ArrayBuffer;
  rangeStart: number;
  rangeEnd: number;
};

export type FileDataResponse = {
  returnCode: number;
  message?: string;
  result?: FileRangeResponse;
};

export type OpenSysFileExplorerRequest = {
  intention: UnifyWebviewPathIntention;
  pathId: string;
  checkdb?: boolean;
};

export type CheckPathExistsRequest = {
  intention: UnifyWebviewPathIntention;
  pathId: string;
  checkdb?: boolean;
};

export type CheckPathExistsResult = {
  exists: boolean;
  type?: 'file' | 'directory' | 'unknown'; // only exist when `exists` was true
};

export type SavePathIdToDBRequest = {
  pathId: string;
  intention: UnifyWebviewPathIntention;
};

export type SavePathIdToDBResult = {
  dbFileId: string;
};

export type OpenFileBySystemAppRequest = {
  pathId: string;
  extensions: string[];
  intention: UnifyWebviewPathIntention;
};

export enum UnifyWebviewPathIntention {
  None = 0,
  Read = 1,
  Write = 2,
  ReadAndWrite = 3,
}

export enum UnifyWebViewFileType {
  Unknown = 0,
  Camera,
  Photo,
  Video,
  Audio,
  File,
  PhotoVideo,
}
